export enum OrganizerActionType {
    setOrganizerMarketingOptIn = 'setOrganizerMarketingOptIn',
    setOrganizerNameAndLogo = 'setOrganizerNameAndLogo',
    setOrganizerUrlAndFollowers = 'setOrganizerUrlAndFollowers',
}

export interface SetOrganizerMarketingOptInAction {
    type: OrganizerActionType.setOrganizerMarketingOptIn;
    payload: boolean;
}

export interface SetOrganizerNameAndLogoAction {
    type: OrganizerActionType.setOrganizerNameAndLogo;
    payload: {
        name: string;
        logoUrl: string;
    };
}

export interface SetOrganizerUrlAndFollowersAction {
    type: OrganizerActionType.setOrganizerUrlAndFollowers;
    payload: {
        url: string;
        followedByYou: boolean;
        numFollowers: number;
    };
}

export const setOrganizerMarketingOptInAction = (
    enableOrganizerMarketingOptIn: boolean,
): SetOrganizerMarketingOptInAction => ({
    type: OrganizerActionType.setOrganizerMarketingOptIn,
    payload: enableOrganizerMarketingOptIn,
});

export const setOrganizerNameAndLogoAction = (organizerData: {
    name: string;
    logoUrl: string;
}): SetOrganizerNameAndLogoAction => ({
    type: OrganizerActionType.setOrganizerNameAndLogo,
    payload: organizerData,
});

export const setOrganizerUrlAndFollowersAction = (organizerData: {
    url: string;
    followedByYou: boolean;
    numFollowers: number;
}): SetOrganizerUrlAndFollowersAction => ({
    type: OrganizerActionType.setOrganizerUrlAndFollowers,
    payload: organizerData,
});

export type OrganizerAction =
    | SetOrganizerMarketingOptInAction
    | SetOrganizerNameAndLogoAction
    | SetOrganizerUrlAndFollowersAction;
